import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';

@Component({
    selector: '[add_doc_to_bene_mobile]',
  templateUrl: 'add-to-bene-mobile.component.html',
})

export class AddDocumentoToBeneMobileComponent {
  @Input()
  beneMobile: BeneMobile;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(bene: BeneMobile) {
    this.onClickAddToEntity.emit(bene);
  }
}
